module.exports = __webpack_public_path__ + "static/img/banner.0fad1c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonSense/banner.jpg
// module id = W+qF
// module chunks = 1